var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-8cb63e34\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./WhyDoMore.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/WhyDoMore.vue
// module id = 204
// module chunks = 1